import Minicart from './minicart';

export default Minicart;
